import { Controller } from "@hotwired/stimulus"

// Potvrzovací modal pro nevratné akce v adminu (mazání apod.).
// Funguje nezávisle na Turbo (Drive je na webu vypnutý, takže data-turbo-confirm
// by se ignorovalo). Formulář dostane data-action="submit->confirm#ask" a
// data-confirm-message; controller je na společném předkovi (admin <body>),
// modal je sdílený jeden pro celou stránku.
export default class extends Controller {
  static targets = ["dialog", "message"]

  // Funguje dvěma způsoby:
  //  - submit->confirm#ask na formuláři (button_to: mazání jedné položky)
  //  - click->confirm#ask na tlačítku uvnitř sdíleného formuláře (hromadná akce);
  //    submitter si pamatujeme, aby se odeslala správná hodnota (name/value).
  ask(event) {
    // Potvrzené odeslání z confirm() projde bez opětovného odchycení (jinak smyčka).
    if (this.bypass) return
    event.preventDefault()
    const el = event.currentTarget
    if (el.tagName === "FORM") {
      this.form = el
      this.submitter = event.submitter || null
    } else {
      this.form = el.form || el.closest("form")
      this.submitter = el
    }
    this.messageTarget.textContent =
      el.dataset.confirmMessage || this.form?.dataset.confirmMessage || "Opravdu provést tuto akci?"
    if (typeof this.dialogTarget.showModal === "function") {
      this.dialogTarget.showModal()
    } else {
      this.dialogTarget.setAttribute("open", "")
    }
  }

  confirm() {
    const { form, submitter } = this
    this.close()
    if (!form) return
    // requestSubmit() spouští submit synchronně → bypass platí jen po tu dobu.
    this.bypass = true
    form.requestSubmit(submitter || undefined)
    this.bypass = false
  }

  cancel() {
    this.form = null
    this.submitter = null
    this.close()
  }

  close() {
    if (typeof this.dialogTarget.close === "function") {
      this.dialogTarget.close()
    } else {
      this.dialogTarget.removeAttribute("open")
    }
  }
}
